export default function removeNewLines(string) {
  return string && string.replace(/(\r\n|\n|\r)/gm, '')
}